export default class UploadInTextarea {
    static init(): void {
        const containers = document.querySelectorAll('.upload-in-textarea');
        loadFileBlocks();

        if (containers.length === 0) {
            return;
        }

        containers.forEach((container) => {
            const input = container.querySelector('input[type="file"]') as HTMLInputElement;

            input.addEventListener('change', () => {
                const fileBlocksContainter = container.querySelector('.upload-in-textarea__files') as HTMLDivElement;
                const oldFileBlocks = fileBlocksContainter.querySelectorAll('.upload-in-textarea__file-block') as NodeListOf<HTMLDivElement>;

                let counter = 0;
                oldFileBlocks.forEach((oldBlock) => {
                    if (counter !== 0) {
                        oldBlock.remove();
                    }
                    counter++;
                });

                if (input.files === null) {
                    return;
                }

                const imgSrc = fileBlocksContainter.dataset.src as string;
                const files = Array.from(input.files);

                files.forEach((file) => {
                    const fileBlock = container.querySelector('.upload-in-textarea__file-block') as HTMLDivElement;
                    const newFileBlock = fileBlock.cloneNode(true) as HTMLDivElement;

                    fileBlocksContainter.append(newFileBlock);
                    newFileBlock.querySelector('.upload-in-textarea__file-name')!.textContent = file.name;
                    newFileBlock.querySelector('.upload-in-textarea__file-img')!.setAttribute('src', imgSrc + file.name.split('.').pop() + '.svg');

                });

                loadFileBlocks();
            });
        });

        function loadFileBlocks(): void {
            const containers = document.querySelectorAll('.upload-in-textarea');

            containers.forEach((container) => {
                const input = container.querySelector('input[type="file"]') as HTMLInputElement;
                if (input.files === null) {
                    return;
                }

                const fileBlocks = container.querySelectorAll('.upload-in-textarea__file-block');

                fileBlocks.forEach((fileBlock) => {
                    fileBlock.addEventListener('click', () => {
                        fileBlock.remove();

                        const dt = new DataTransfer();

                        if (input.files === null) {
                            return;
                        }
                        const files = Array.from(input.files);

                        files.forEach((file) => {
                            if (file !== files[0]) {
                                dt.items.add(file);
                            }
                        });

                        input.onchange = null;
                        input.files = dt.files;
                    });
                });
            });
        }
    }
}
